import { useState, useEffect } from "react";
import axios from "axios";

const useAxios = () => {
  
  const [getResponse, setGetResponse] = useState<any>([]);
  const [getResponseLoading, setGetResponseLoading] = useState(false);
  const [getResponseError, setGetResponseError] = useState<any>();
  const API_URL = process.env.REACT_APP_HOST_API;

  const setUserId = () => {
    const docplaceData = localStorage.getItem("docplace");
    if (docplaceData) {
      return JSON.parse(docplaceData).userId || "";
    }
    return "";
  };

  const setCustomerId = () => {
    const docplaceData = localStorage.getItem("docplace");
    if (docplaceData) {
      return JSON.parse(docplaceData).customerId || "";
    }
    return "";
  };

  const setToken = () => {
    const docplaceData = localStorage.getItem("docplace")
    if (docplaceData) {
      return "Bearer " + JSON.parse(docplaceData).token || "";
    }
    return "";
  };

  const fetchBatch = async (url: string) => {
    setGetResponseLoading(true);
    try {
      const response = await axios.get(`${API_URL}${url}`, {
        headers: {
          accept: "application/json",
          customerId: setCustomerId(),
          authorization: setToken(),
        },
      });
      setGetResponse(response.data.data);
    } catch (error) {
      if (error) {
        setGetResponseError(error);
      }
    } finally {
      setGetResponseLoading(false);
    }
  };



  return {
    fetchBatch,
    getResponse,
    getResponseLoading,
    getResponseError,
  };
};

export default useAxios;
